import React from 'react';

interface OperatingRoomCountProps {
  row: any;
  field: string;
  isCurrency?: boolean;
}

const OperatingRoomCount: React.FC<OperatingRoomCountProps> = ({
  row,
  field,
}) => {
  const value = row?.[field];
  const numericValue = Number(value);

  if (value == null || !Number.isFinite(numericValue)) {
    return <div className="w-full text-right text-sm">Unknown</div>;
  }

  const formattedValue = new Intl.NumberFormat('en-US').format(numericValue);

  return <div className="w-full text-right">{formattedValue}</div>;
};

export default OperatingRoomCount;
